@if (!emailSend()) {
  <div class="login-form">
    <div class="form-group">
      <label for="email" class="form-label">Adresse email</label>
      <div class="input-wrapper">
        <ng-icon name="iconoirMail" class="input-icon" size="18"></ng-icon>
        <input
          autocomplete="username"
          name="email"
          id="email"
          type="email"
          [formControl]="emailCtrl"
          class="form-input"
          placeholder="nom@entreprise.com"
          [attr.aria-invalid]="emailCtrl.touched && emailCtrl.invalid"
          aria-describedby="email-error"
          (keydown.enter)="sendLoginEmail()"
        >
      </div>
      <span id="email-error" aria-live="polite">
        @if (emailCtrl.hasError('required') && emailCtrl.touched) {
          <span class="error-message">Saisissez votre adresse email pour continuer.</span>
        }
        @if (emailCtrl.hasError('email') && emailCtrl.touched) {
          <span class="error-message">Cette adresse email n'est pas valide. Exemple : nom&#64;entreprise.com</span>
        }
      </span>
    </div>

    @if (!connexionByPassword() && errorMessage()) {
      <p class="form-error-banner" role="alert">
        <ng-icon name="iconoirWarningCircle" size="18"></ng-icon>
        <span>{{ errorMessage() }}</span>
      </p>
    }

    <div class="login-btn-wrapper">
      @if (!connexionByPassword()) {
        <app-btn
          class="login-btn"
          [config]="{
            type: 'filled',
            color: 'coffee',
            icon: 'iconoirArrowRight',
            disabled: emailCtrl.touched && emailCtrl.invalid
          }"
          (click)="sendLoginEmail()"
        >
          Recevoir un code de connexion
        </app-btn>
      }
    </div>

    <div class="password-toggle" [class.password-toggle--active]="connexionByPassword()">
      <button type="button" class="otp-action-btn" (click)="connexionByPassword.set(!connexionByPassword()); errorMessage.set(null)">
        {{ !connexionByPassword() ? 'Se connecter avec un mot de passe' : 'Recevoir un code par email' }}
      </button>
    </div>

    @if (connexionByPassword()) {
      <div class="form-group">
        <div class="form-label-row">
          <label for="password" class="form-label">Mot de passe</label>
          <a routerLink="/reset-password" class="forgot-password-link">Mot de passe oublié ?</a>
        </div>
        <div class="input-wrapper">
          <ng-icon name="iconoirLock" class="input-icon" size="18"></ng-icon>
          <input
            autocomplete="current-password"
            name="password"
            id="password"
            type="password"
            [formControl]="passwordCtrl"
            class="form-input"
            placeholder="Votre mot de passe"
            (keydown.enter)="login()"
          >
        </div>
      </div>

      @if (errorMessage()) {
        <p class="form-error-banner" role="alert">
          <ng-icon name="iconoirWarningCircle" size="18"></ng-icon>
          <span>{{ errorMessage() }}</span>
        </p>
      }

      <div class="login-btn-wrapper">
        <app-btn
          class="login-btn"
          [config]="{
            type: 'filled',
            color: 'coffee',
            icon: 'iconoirArrowRight',
            disabled: emailCtrl.invalid || passwordCtrl.invalid
          }"
          (click)="login()"
        >
          Se connecter
        </app-btn>
      </div>
    }
  </div>

  <!-- Connexion Google : domaines web-atrio.com uniquement (le composant se masque ailleurs). -->
  <app-login-by-social-auth />

  @if (isLocalhost) {
    <div class="quick-login-section">
      <div class="divider">
        <span class="divider-text">Comptes de test</span>
      </div>
      <div class="quick-login-btn-wrapper">
        <app-btn
          [config]="{
            type: 'outline',
            color: 'cream',
            icon: 'iconoirUser'
          }"
          (click)="showDevPanel.set(true)"
        >
          Choisir un compte de test
        </app-btn>
      </div>
    </div>
  }

  @if (showDevPanel()) {
    <div class="dev-panel-overlay" (click)="showDevPanel.set(false)">
      <div class="dev-panel" (click)="$event.stopPropagation()">
        <div class="dev-panel__header">
          <div class="dev-panel__header-top">
            <div>
              <h2>Comptes de test</h2>
              <p>Cliquez sur un compte pour vous connecter</p>
            </div>
            <button type="button" class="dev-panel__close" aria-label="Fermer" (click)="showDevPanel.set(false)">&times;</button>
          </div>
          <!-- Onglets par organisation (masqués pendant une recherche : elle est globale) -->
          @if (!searchQuery()) {
            <div class="pill-tabs dev-panel__tabs" role="tablist" aria-label="Organisations">
              @for (tab of organisationTabs; track tab) {
                <button
                  type="button"
                  class="pill-tab dev-panel__tab"
                  role="tab"
                  [attr.aria-selected]="activeOrgTab() === tab"
                  (click)="selectOrgTab(tab)"
                >
                  {{ tab }}
                </button>
              }
            </div>
          }
          <div class="dev-panel__search">
            <svg class="dev-panel__search-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
            </svg>
            <input
              class="dev-panel__search-input"
              type="text"
              placeholder="Rechercher par nom, email ou rôle…"
              [value]="searchQuery()"
              (input)="searchQuery.set($any($event.target).value)"
              autocomplete="off"
            />
            @if (searchQuery()) {
              <button class="dev-panel__search-clear" (click)="searchQuery.set('')">&times;</button>
            }
          </div>
        </div>
        <div class="dev-panel__body">
          @if (filteredGroups().length === 0) {
            <div class="dev-panel__empty">
              <p>Aucun compte trouvé pour « {{ searchQuery() }} »</p>
            </div>
          }
          @for (group of filteredGroups(); track group.roleKey) {
            <div class="dev-group" [class.dev-group--open]="openGroup() === group.roleKey || !!searchQuery()">
              <button
                class="dev-group__header"
                (click)="!searchQuery() && toggleGroup(group.roleKey)"
                [class.dev-group__header--active]="openGroup() === group.roleKey || !!searchQuery()"
                [attr.aria-expanded]="openGroup() === group.roleKey || !!searchQuery()"
              >
                <div class="dev-group__title">
                  <span class="dev-group__badge" [attr.data-role-key]="group.roleKey">{{ group.role }}</span>
                  <span class="dev-group__count">{{ group.accounts.length }} compte{{ group.accounts.length > 1 ? 's' : '' }}</span>
                </div>
                @if (!searchQuery()) {
                  <svg
                    class="dev-group__chevron"
                    [class.dev-group__chevron--open]="openGroup() === group.roleKey"
                    width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"
                  >
                    <polyline points="6 9 12 15 18 9"/>
                  </svg>
                }
              </button>
              @if (openGroup() === group.roleKey || !!searchQuery()) {
                <div class="dev-group__list">
                  @for (account of group.accounts; track account.email) {
                    <button
                      class="dev-row"
                      [class.dev-row--admin]="account.roles.includes('WA_ADMIN')"
                      [class.dev-row--loading]="loggingIn() === account.email"
                      [disabled]="loggingIn() !== null"
                      (click)="quickLogin(account)"
                    >
                      <app-avatar class="dev-row__avatar" [textPass]="account.name" [sizePass]="36" />
                      <div class="dev-row__info">
                        <span class="dev-row__name">{{ account.name }}</span>
                        <span class="dev-row__email">{{ account.email }}</span>
                        <span class="dev-row__desc">{{ account.description }}</span>
                      </div>
                      <div class="dev-row__meta">
                        <span class="dev-row__agency">{{ account.agency }}</span>
                        @if (account.roles.length === 0) {
                          <span class="dev-row__badge dev-row__badge--none">Aucun rôle</span>
                        } @else {
                          @for (role of account.roles; track role) {
                            <span class="dev-row__badge" [attr.data-role]="role">{{ role }}</span>
                          }
                        }
                      </div>
                      @if (loggingIn() === account.email) {
                        <span class="dev-row__spinner"></span>
                      }
                    </button>
                  }
                </div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  }

} @else {
  <div class="otp-container">
    <div class="otp-header">
      <div class="otp-icon">
        <ng-icon name="iconoirMail" size="24"></ng-icon>
      </div>
      <p class="otp-message">Un code à 6 chiffres a été envoyé à</p>
      <p class="otp-email">{{ emailCtrl.value }}</p>
    </div>

    <div class="otp-input-section">
      <ngx-otp-input #otpInput [options]="otpOptions" [status]="otpStatut"
        (otpChange)="changeOtp($event)"></ngx-otp-input>
    </div>

    <div class="otp-actions">
      <button class="otp-action-btn" (click)="sendLoginEmail()" [disabled]="counter() > 0">
        Renvoyer le code
        @if (counter() > 0) {
          <span class="counter">({{ counter() }}s)</span>
        }
      </button>
      <button class="otp-action-btn otp-action-btn--secondary" (click)="emailSend.set(false)">
        Modifier l'email
      </button>
    </div>
  </div>
}
